import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IGetTiktokPostsData, TiktokPostsPaginationResponse } from '../Models/ITiktokPost';
import { ITiktokPostDetailsPutDto } from '../Models/ITiktokPostDetailsPutDto';
import { ITiktokComment } from '../Models/ITiktokComment';
import { map } from 'rxjs/operators';
import { IFilterBody, IApiResponseDto, IPagination, IPostType, ITopic, IPolitician } from '../../../helpers/general.interface';
import { HelperFunctions } from '../../../helpers/HelperFunctions';


@Injectable({
  providedIn: 'root'
})
export class TiktokService {
  constructor(private http: HttpClient) {}

  public getAllPosts(pagination: IPagination, sortBy: string, sortDir: string, searchVal: string, filters: IFilterBody[]): Observable<TiktokPostsPaginationResponse> {
    let params: HttpParams = new HttpParams();
    

    if (pagination) {
      params = HelperFunctions.addPaginationToParams(params, pagination);
    }
    
    if (sortBy)
      params = params.set('sortBy', sortBy);

    
    if (sortDir)
      params = params.set('sortDir', sortDir);
    
    if (searchVal)
      params = params.set('searchVal', searchVal);
    
    return this.http.post<TiktokPostsPaginationResponse>(
      `${environment.tiktokUrl}/Tiktok/list`, filters || [], { params: params }
    );
  }

   public updatePostDetails(body: ITiktokPostDetailsPutDto): Observable<IApiResponseDto> {
    let response: Observable<IApiResponseDto> = this.http.put<IApiResponseDto>(`${environment.tiktokUrl}/Tiktok`, body)
    return response
   }


   public getPostDetails(id: string): Observable<IGetTiktokPostsData> {
    return this.http.get<IGetTiktokPostsData>(`${environment.tiktokUrl}/Tiktok/${id}`);
  }
  


   public getPostComments(id: string): Observable<ITiktokComment> {

    let response: Observable<ITiktokComment> = this.http.get<ITiktokComment>(`${environment.tiktokUrl}/Tiktok/${id}/comments`)
    return response
   }

   public getCommentDetails(id: string): Observable<ITiktokComment> {

    let response: Observable<ITiktokComment> = this.http.get<ITiktokComment>(`${environment.tiktokUrl}/Comment/${id}`)
    return response
   }


   public getPoliticians(): Observable<IPolitician[]> {
    let response = this.http.get<IPolitician[]>(`${environment.tiktokUrl}/Politician/profile-names`);
    return response;
   }
  

   public getAttackedPoliticians(): Observable<IPolitician[]> {
     return this.http.get<IPolitician[]>(`${environment.tiktokUrl}/Politician/attacked-politicians`)
       .pipe(
          map(response => response.map(item => ({
            name: item.name,
            id: item.name
        } as IPolitician))));
   }


    public getPoliticianDetails(politicianId: string): Observable<IPolitician> {
       let response = this.http.get<IPolitician>(`${environment.tiktokUrl}/Politician/${politicianId}`);
       return response;
    }

   public getPostTypes(): Observable<IPostType[]> {

    let response: Observable<IPostType[]> = this.http.get<IPostType[]>(`${environment.tiktokUrl}/PostType/list`)
    return response
   }


   public getPostTopics(): Observable<ITopic[]> {

    let response: Observable<ITopic[]> = this.http.get<ITopic[]>(`${environment.tiktokUrl}/topic/list`)
    return response
   }
}